import { FinanceType } from "@/enums/enums";
import { NewObject } from "./shareHelper";

export function FilterAccountOfTransaction(_accountList: any, financeType: any) {
  const accountList: any = [];
  const ExcludedAccountCodeFromCreateTransaction = [
    111101,
    111201,
    111301,
    111401,
    112101,
    113101,
    113102,
    212101,
    212102,
  ];
  _accountList.forEach((account: any) => {
    const accountExcluded = ExcludedAccountCodeFromCreateTransaction.find((item: any) => {
      return item == account.code ? true : false;
    });
    if (!accountExcluded) {
      accountList.push(NewObject(account));
    }
  });

  const sortAccountList: any = [];
  const primaryAccountType = financeType == FinanceType.InFlow ? "4" : "5";
  accountList.forEach((account: any) => {
    const subStringAccountCode = account.code.substring(0, 1);
    if (subStringAccountCode == primaryAccountType) {
      sortAccountList.push(account);
    }
  });
  accountList.forEach((account: any) => {
    const accountSelected = sortAccountList.find((item: any) => {
      return item.code == account.code ? true : false;
    });

    if (!accountSelected) {
      sortAccountList.push(account);
    }
  });

  return sortAccountList;
}
